
























import Vue from 'vue'
import Presenter, { IPresenter } from './presenter'
import Loading from '@/components/shared/atoms/Loading'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'
import TextLink from '@/components/shared/atoms/TextLink'
import Button from '@/components/shared/atoms/Button/Button'
import FetchFAQContentUseCase from '@/usecases/faq/FetchFAQContentUseCase'

export default Vue.extend({
  components: {
    Loading,
    LinkButton,
    TextLink,
    Button
  },
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    contentId: {
      type: Number,
      required: true
    },
    isModal: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        FAQRepository: this.$FAQRepository,
        contentId: this.contentId
      })
    },
    contactPath(): string {
      return this.categoryId ? `/contact?categoryId=${this.categoryId}` : '/contact'
    }
  },
  async mounted() {
    // Modalとして呼ばれる場合など、データの取得が行われていない場合はこちらで取得する
    if (!this.presenter.content) {
      try {
        const fetchFAQContentUseCase = new FetchFAQContentUseCase({
          snapsnapGateway: this.$snapsnapGateway,

          FAQRepository: this.$FAQRepository
        })

        await fetchFAQContentUseCase.execute(this.contentId)
      } catch (e) {
        console.log(e)
        // TODO: Handle error
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('close')
    }
  }
})
